<template>
  <div class="logoutDiv">
    <div class="logo">
      <img src="../assets/img/exit_icon.png" alt="" width="47%" />
      <div class="desc2">
        确认要退出当前的账户登录吗？
      </div>
    </div>
    <div class="footer-cont2" style="background: #fff;">
      <van-button type="primary" block class="btnStyle1" @click="confirmExit"
        >确认退出</van-button
      >
      <van-button
        block
        class="btnStyle2"
        @click="
          $router.push({
            path: 'rhwxWelcome'
          })
        "
        >取消</van-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      comId: "",
      appId: ""
    };
  },
  created() {},
  mounted() {
    this.getInfo();
  },
  methods: {
    confirmExit() {
      this.$common
        .http({
          url: "/api/authorize/logout"
        })
        .then(() => {
          this.$common.mbToastSuccess("退出成功");
          setTimeout(() => {
            this.$router.push({
              path: `/rhwxOpenIdLogin?com_id=${this.comId}&app_id=${this.appId}&type=UNIT`
            });
          }, 1500);
        });
    },

    // 获取单位信息
    getInfo() {
      this.$common
        .http({
          url: "/api/supplier/account_info"
        })
        .then(res1 => {
          this.comId = res1.data.data.com_id;
          this.appId = res1.data.data.app_id;
        });
    }
  }
};
</script>
<style lang="less">
@import "../assets/css/common";
.logoutDiv {
  .logo {
    text-align: center;
    padding: 42px 27px 36px;
  }
  .desc2 {
    font-size: 17px;
    color: #999;
    margin-top: 10px;
  }
}
</style>
